import React from 'react';

import { ThemeProvider } from '@mui/material/styles';
import 'dayjs/locale/en-au';

import type { Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

// ControlledStaticDatePicker wraps its own LocalizationProvider with no
// `adapterLocale` prop. LocalizationProvider reads its default props from the
// theme, so giving this subtree the Australian dayjs locale (weekStart: 1)
// starts calendar weeks on Monday without touching the shared picker.
const withAustralianWeeks = (outer: Theme): Theme =>
  ({
    ...outer,
    components: {
      ...outer.components,
      MuiLocalizationProvider: { defaultProps: { adapterLocale: 'en-au' } }
    }
  }) as Theme;

const MondayFirstWeeks = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={withAustralianWeeks}>{children}</ThemeProvider>
);

export default MondayFirstWeeks;
